import React, { useEffect, useState, useContext } from "react";
import api from "../../../../services/api";
import EmpresaContext from "../../../../contexts/Empresa";

import { Container, Gradient, LoadingContainer } from "./styles";

import RankingEmpresas from "../charts/RankingEmpresas";

import {
  Container as BootstrapContainer,
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Spinner,
} from "reactstrap";

interface IGraficos {
  notify(type: string, msg: string): void;
  mes: string;
  ano: string;
  equipe: any;
  campanha: any;
  isGestor: boolean;
  setCampanha: any;
  unidade: string;
  tipoProduto: string;
}

const Graficos: React.FC<IGraficos> = ({
  notify,
  mes,
  ano,
  equipe,
  unidade,
  tipoProduto,
  isGestor,
}) => {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [loading, setLoaging] = useState(false);
  const [cardHeight, setCardHeight] = useState();

  return (
    <>
      <Container
      // className='header d-flex align-items-center'
      >
        <BootstrapContainer fluid className="mt-2">
          {isGestor ? (
            <Row className="mt-4">
              <Col lg="12" md="12" sm="12" xs="12">
                <RankingEmpresas
                  notify={notify}
                  mes={mes}
                  ano={ano}
                  unidade={unidade}
                  tipoProduto={tipoProduto}
                  setCardHeight={setCardHeight}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col lg="12" md="12" sm="12" xs="12">
                <RankingEmpresas
                  notify={notify}
                  mes={mes}
                  ano={ano}
                  unidade={unidade}
                  tipoProduto={tipoProduto}
                  setCardHeight={setCardHeight}
                />
              </Col>
            </Row>
          )}
        </BootstrapContainer>
      </Container>
    </>
  );
};

export default Graficos;
